import { useId } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import type { TooltipProps } from './types';

export function Tooltip(props: TooltipProps) {
  const id = useId();

  return (
    <span data-tooltip-id={id} className="inline-flex">
      <ReactTooltip
        id={id}
        className="rounded-lg! bg-white! px-3! py-1.5! text-sm! text-spark-text-primary! shadow-md transition-opacity! duration-300!"
        opacity={1}
        border="1px solid #d1d5db"
      >
        {props.content}
      </ReactTooltip>
      {props.children}
    </span>
  );
}
